<template src="./component.html"></template>

<script>
export default {
  name: "Promo"
}
</script>

<style src="./component.scss" scoped lang="scss"/>
